/**
 * Support template.
 */
import Animator from '@components/elements/animator/animator';
import Body from '@components/sections/support/supportBody';
import Button from '@components/atoms/buttons/confirmButton';
import Container from '@components/atoms/container/supportContainer';
import QR from '@components/sections/support/supportQR';
import useSupportTemplate from '../lib/useSupportTemplate';
import { selectMenuCollapse } from '@shared/store/slices/menu.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Support template component.
 */
export default function SupportTemplate() {
  const { callbacks, literals, props } = useSupportTemplate();
  const menuExpanded = !useAppSelector(selectMenuCollapse);

  return (
    <Animator
      id={'supportContainer'}
      type={Animator.Type.SETTING}
      collapse={{ horizontal: menuExpanded }}
    >
      <Container {...callbacks.container}>
        <Body />
        <QR />
        <Button {...props.button} onClick={callbacks.button}>
          {literals.button}
        </Button>
      </Container>
    </Animator>
  );
}
